import { __decorate } from 'tslib';
import { BehaviorSubject } from 'rxjs';
import { $logger } from '../../controllers/logger/logger.js';
import { Service } from '../../decorators/class/service.js';

/**
 * 全局状态存储服务
 *
 * @public
 */
let StateManager = class StateManager {
    constructor() {
        this.state = new Map();
    }
    /**
     * 在状态管理器中注册一个变量
     *
     * @param key - 状态名
     * @param defaultValue - 状态值
     */
    register(key, defaultValue) {
        if (this.state.has(key)) {
            $logger.warn(`key ${key} has already been registered, thus ignored.`);
        }
        else {
            this.state.set(key, new BehaviorSubject(defaultValue));
        }
        return this.get(key);
    }
    /**
     * 判断状态是否已经初始化
     *
     * @param key - 状态名
     */
    has(key) {
        return this.state.has(key);
    }
    /**
     * 获取状态 Subject
     *
     * @param key - 状态名
     */
    get(key) {
        return this.state.get(key);
    }
    /**
     * 获取状态当前值
     *
     * @param key - 状态名
     */
    getValue(key) {
        if (this.state.has(key)) {
            const value = this.get(key).getValue();
            return value;
        }
        return null;
    }
    /**
     * 更新状态
     *
     * @param key - 状态名
     * @param value - 新的状态值
     */
    update(key, value) {
        if (this.state.has(key)) {
            this.get(key).next(value);
        }
        else {
            $logger.warn(`Key "${key}" is not exists. Update ignored.`);
        }
    }
    /**
     * 更新状态，没有的话就创建状态
     * @param key - 状态名
     * @param value - 状态值
     */
    upsert(key, value) {
        if (this.state.has(key)) {
            this.get(key).next(value);
        }
        else {
            this.register(key, value);
        }
    }
    /**
     * 清空状态
     *
     * @param key - 状态名
     */
    clear(key) {
        this.state.delete(key);
    }
};
StateManager = __decorate([
    Service({ overridable: true })
], StateManager);

export { StateManager };
//# sourceMappingURL=state-manager.js.map
